export default function extractPhoneNumber(phone: string) {
    const input = "(+62) 821-8818-8336";
    const cleaned = input.replace(/[^\d+]/g, '');

    return cleaned
}